import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
  BarController
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, BarController);

function formatMinutesToHHMM(minutes: number): string {
  const h = Math.floor(minutes / 60).toString().padStart(2, '0');
  const m = (minutes % 60).toString().padStart(2, '0');
  return `${h}:${m}`;
}

export const chartOptionsQtd = (totalOS: number): ChartOptions<'bar'> => ({
  responsive: true,
  indexAxis: 'y',
  plugins: {
    legend: { position: 'top' },
    title: { display: true, text: `Quantidade de OS por Agrupamento | Total: ${totalOS}` },
  },
  scales: {
    x: { beginAtZero: true },
  },
});

export const chartOptionsTime: ChartOptions<'bar'> = {
  responsive: true,
  indexAxis: 'y',
  plugins: {
    legend: { position: 'top' },
    title: { display: true, text: 'Tempo de Atendimento' },
    tooltip: {
      callbacks: {
        label: (context) => {
          const value = context.parsed.x;
          return `Tempo: ${formatMinutesToHHMM(value)}`;
        },
      },
    },
  },
  scales: {
    x: {
      beginAtZero: true,
      ticks: {
        callback: (value) => {
          const num = Number(value);
          return isNaN(num) ? value : formatMinutesToHHMM(num);
        },
      },
    },
  },
};
